<template>
    <dialogBox >
        <template v-slot:title>{{ $t('Add') }}</template>
        <template v-slot:body>
            <div class="mb-3">
                <h4 class="fs-15">{{ $t('Point_name') }}</h4>
                <input type="text" class="form-control" id="contactNumber" v-model="form.title">
            </div>
        </template>
        <template v-slot:footer-bottom>
            <div style="margin: auto;">
                <a class="btn btn-link link-success fw-medium" data-bs-dismiss="modal" @click="$emit('close')"><i class="ri-close-line me-1 align-middle"></i> {{ $t('close') }} </a>
                <button 
                    type="button" 
                    class="btn btn-primary" 
                    v-on:click="create"
                >
                    {{ $t('Add') }}
                </button>
            </div>
        </template>
    </dialogBox>
</template>

<script>
import dialogBox from '@/components/modal/dialog'
import { Attributes } from '@/API.js';
import { storeS } from '@/store.js'

let apiServe = new Attributes();

export default {
components: { dialogBox },
data() {
    return {
        // modalDialog: false,
        form:{
            id: "",
            title: ""
        },
    };
},
created(){
},
methods: {
    create() {
        this.form.id = Math.floor(Math.random() * (9999 - 10)) + 10;
        apiServe.addAttr(this.form).then(res => {
            if(res){
                this.$toast.success(this.$t('сreatedT'));
                this.$emit('close')
                this.eventBus.emit('saveAttr', true)
            }
        })
    },
},
computed: {
    user() {
        return storeS.userbase
    }
}
}
</script>